export default {
  sm: `
  24시간 안전한 데이터센터
  `,
  md: `
  24시간 안전한
  데이터센터
  `,
};  